import React from "react";

const HandleRoute = ({element}) => {
  if (window.location.pathname === "/") {
    localStorage.clear();
    window.location.href = "https://onboardify.tasc360.com";
  }
  return element;
};

export default HandleRoute;
